import * as React from "react";
import { ButtonOutline } from "@grandvisionhq/iris-ui";
import { useCancelAndReturnsModalContentSlot } from "../../../../../../context/context/CancelAndReturnsModalContentContext.js";
import CancelAndReturnsModal from "../../../../CancelAndReturns/Orders/components/CancelAndReturns/CancelAndReturnsModal.js";
import OrderHeader from "../../../../Header/Orders/components/Header/OrderHeader.js";
/* empty css           */
const Order = ({
  children,
  footer,
  labels,
  orderDate,
  orderNumber,
  shipmentStatus,
  orderStatus,
  paymentStatus,
  onReorder,
  isOrderWorkflowStatusEnabled,
  onOpenCancelReturnsModal,
  isCancelReturnsModalOpen,
  onCloseCancelReturnsModal,
  isPaid,
  isReturnsEnabled,
  shouldShowOrderDate
}) => {
  const { Slots } = useCancelAndReturnsModalContentSlot();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    OrderHeader,
    {
      orderDate,
      orderNumber,
      shipmentStatus,
      orderStatus,
      paymentStatus,
      isOrderWorkflowStatusEnabled,
      onReorder,
      className: "order__header",
      shouldShowOrderDate
    }
  ), children, /* @__PURE__ */ React.createElement("div", { className: "order__footer-returns-modal" }, isReturnsEnabled ? null : Slots.ModalContent && isPaid ? (
    // Returns call-customer-service modal
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      ButtonOutline,
      {
        className: "returns-modal-button",
        onPress: () => onOpenCancelReturnsModal()
      },
      labels.cancelAndReturns
    ), isCancelReturnsModalOpen && /* @__PURE__ */ React.createElement(
      CancelAndReturnsModal,
      {
        ModalContent: Slots.ModalContent,
        onCloseCancelReturnsModal
      }
    ))
  ) : null), footer && /* @__PURE__ */ React.createElement("div", { className: "order__footer" }, footer));
};
export {
  Order,
  Order as default
};
//# sourceMappingURL=Order.js.map
